var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"mt-3"},[_c('InvoiceViewer',{attrs:{"userId":_vm.user_id,"targetId":_vm.targetId}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }